import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../../featureFlags';
import SettingsShellWrapper from '../SettingsShellWrapper.vue';
import TicketTypesIndex from './Index.vue';

// Administrator only, and behind the same flag as the tickets themselves: the
// screen configures who can see which tickets, so the server enforces the role
// again on every write (T-13). `permissions` is what the router guard reads;
// `featureFlag` is what the sidebar and the settings home read to decide whether
// to offer the row at all.
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/ticket-types'),
      // The page owns its header via SettingsPageShell, so it needs the bare pane.
      component: SettingsShellWrapper,
      children: [
        {
          path: '',
          name: 'settings_ticket_types',
          component: TicketTypesIndex,
          meta: {
            featureFlag: FEATURE_FLAGS.SUPPORT_CASES,
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
